/* unplugin-vue-components disabled */import script from "./GEOLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./GEOLoading.vue?vue&type=script&setup=true&lang=ts"

import "./GEOLoading.vue?vue&type=style&index=0&id=ec843c46&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec843c46"]])

export default __exports__